import React from 'react';
export const Header = () => {
  return <div className="flex justify-center py-8" data-id="element-65">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/b2kw2oJmb8JUi9aYWVqUFj/pasted-image.png" alt="SVRN PRO Logo" className="h-[3.25rem]" data-id="element-66" />
    </div>;
};